import { ICancelledPartnerItem } from '@/models/cancelledOrders.model';

export const sortCancelledPartnersByShare = (items: ICancelledPartnerItem[]): ICancelledPartnerItem[] =>
  [...items].sort((a, b) => {
    const shareDiff = b.cancelled_share_percent - a.cancelled_share_percent;
    if (shareDiff !== 0) return shareDiff;
    return (b.cancelled_count ?? 0) - (a.cancelled_count ?? 0);
  });
